module.exports = __webpack_public_path__ + "static/media/car-valet.6b4e6d4b.png";